import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../utils/rtk-query';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const LOADBOARD_PERMISSION = 'ryantrans.Loadboard';
export const BOOKIT_NOW_PERMISSION = 'ryantrans.LoadboardBook';

const FREIGHT_VIEW_ACCESS_PERMISSION_LEVEL = 'Freight - View Loads';
const FREIGHT_FULL_ACCESS_PERMISSION_LEVEL = 'Freight - Full Access';

export interface CompanyPermissions {
  companyAdminName: string;
  companyAdminEmail: string;
  companyPermissions: string[];
  onboardingStatus: string;
  rulesAssessment: string | null;
  status: string;
  noDispatch: boolean;
  certified: boolean;
}

export interface CarrierAccesPayload {
  userEmail: string;
  primaryEmail: string;
  permissionRequested: string;
  currentPermission: string;
  comments: string;
}

const freightPermissionServiceApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: config.registrationService,
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    getCarrierPermissions: builder.query<CompanyPermissions, string | undefined>({
      query: (carrierId) => {
        if (!carrierId) {
          throw new Error('CarrierId is required');
        }
        return {
          url: `/carrier/${carrierId}`,
          method: 'GET',
        };
      },
      async onQueryStarted(carrierId, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(setPermissionsData(data));
      },
    }),
    requestCarrierAccess: builder.mutation<any, CarrierAccesPayload>({
      query: (payload) => {
        return {
          url: `/users/${payload.userEmail}/request-carrier-access`,
          method: 'POST',
          data: payload,
        };
      },
    }),
  }),
});

interface UserPermissionsLevel {
  dialogOpen: boolean;
}

const permissionDialogInitialState: UserPermissionsLevel = {
  dialogOpen: false,
};

export const permissionDialogSlice = createSlice({
  name: 'permissionDialog',
  initialState: permissionDialogInitialState,
  reducers: {
    openPermissionDialog: (state) => {
      state.dialogOpen = true;
    },
    closePermisssionDialog: (state) => {
      state.dialogOpen = false;
    },
  },
});

interface CarrierPermissionsState {
  data: CompanyPermissions | null;
}

const CarrierPermissionsInitialState: CarrierPermissionsState = {
  data: null,
};

export const carrierPermissionsDataSlice = createSlice({
  name: 'carrierPermissionsData',
  initialState: CarrierPermissionsInitialState,
  reducers: {
    setPermissionsData: (state, action: PayloadAction<CompanyPermissions>) => {
      state.data = action.payload;
    },
  },
});

export const { useGetCarrierPermissionsQuery, useRequestCarrierAccessMutation } = freightPermissionServiceApi;

export const { openPermissionDialog, closePermisssionDialog } = permissionDialogSlice.actions;

export const { setPermissionsData } = carrierPermissionsDataSlice.actions;

export const getPermissionsLevel = (permissions: string[]): string => {
  if (permissions.includes(BOOKIT_NOW_PERMISSION)) {
    return FREIGHT_FULL_ACCESS_PERMISSION_LEVEL;
  }
  if (permissions.includes(LOADBOARD_PERMISSION)) {
    return FREIGHT_VIEW_ACCESS_PERMISSION_LEVEL;
  }

  return 'No Freight';
};

export default freightPermissionServiceApi;
